import React from 'react';

type LibraryFilterToggleProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'type'> & {
  activeCount?: number;
  expanded: boolean;
  label?: string;
};

/** Mobile disclosure for frequent filters. Global navigation alone uses a hamburger. */
export const LibraryFilterToggle = React.forwardRef<HTMLButtonElement, LibraryFilterToggleProps>(function LibraryFilterToggle({
  activeCount = 0,
  className,
  expanded,
  label = 'Filters',
  ...buttonProps
}, ref) {
  const classes = ['library-toolbar__filter-toggle', className].filter(Boolean).join(' ');
  const stateLabel = expanded ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`;
  // The accessible name replaces the visible text, so it carries the count too.
  const accessibleName = activeCount > 0 ? `${stateLabel}, ${activeCount} active` : stateLabel;

  return (
    <button
      {...buttonProps}
      ref={ref}
      type="button"
      className={classes}
      aria-expanded={expanded}
      aria-label={accessibleName}
      title={stateLabel}
      data-active={activeCount > 0 ? 'true' : 'false'}
    >
      <svg
        className="library-toolbar__filter-toggle-icon"
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M4 5h16l-6.5 7.2V18l-3 1.5v-7.3L4 5Z" />
      </svg>
      <span>{label}</span>
      {activeCount > 0 ? (
        <span className="library-toolbar__filter-toggle-count" aria-label={`${activeCount} active`}>
          {activeCount}
        </span>
      ) : null}
    </button>
  );
});

export default LibraryFilterToggle;
